import { Factory } from "lucide-react";
import { Button } from "@/components/ui/button";
import { loc } from "@/lib/numerals";
import { useTn } from "@/lib/i18n";

const n = (v) => loc(Number(v || 0).toLocaleString("en-IN"));

export function PlanningRow({ r, canCreate, onCreateOrder }) {
  const tn = useTn();
  return (
    <tr data-testid={`planning-row-${r.sku}`}>
      <td className="px-4 py-2.5">
        <p className="font-semibold text-slate-800">{tn(r.name)}</p>
        <p className="text-[11px] text-slate-400 font-mono-data">{r.sku}</p>
      </td>
      <td className="px-4 py-2.5 text-right font-mono-data text-slate-600" data-testid={`planning-demand-${r.sku}`}>{n(r.pending_demand)} {r.unit}</td>
      <td className="px-4 py-2.5 text-right font-mono-data text-violet-600" data-testid={`planning-reserved-${r.sku}`}>{r.reserved > 0 ? `${n(r.reserved)} ${r.unit}` : "—"}</td>
      <td className="px-4 py-2.5 text-right font-mono-data text-slate-600" data-testid={`planning-stock-${r.sku}`}>{n(r.available_stock)} {r.unit}</td>
      <td className="px-4 py-2.5 text-right font-mono-data text-slate-500" data-testid={`planning-wip-${r.sku}`}>{n(r.in_production)} {r.unit}</td>
      <td className="px-4 py-2.5 text-right font-mono-data font-bold text-blue-600" data-testid={`planning-need-${r.sku}`}>{n(r.need_to_produce)} {r.unit}</td>
      <td className="px-4 py-2.5 text-right whitespace-nowrap">
        {canCreate ? (
          <Button size="sm" className="h-7 text-[11px] bg-blue-600 hover:bg-blue-700"
            onClick={() => onCreateOrder({ product_name: r.name, bom_item_id: r.id, target_quantity: Math.ceil(r.need_to_produce) })}
            data-testid={`planning-create-${r.sku}`}>
            <Factory className="h-3 w-3 mr-1" /> Create Production Order
          </Button>
        ) : <span className="text-[11px] text-slate-400">—</span>}
      </td>
    </tr>
  );
}
